import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import TokenWithNetwork from '../TokenWithNetwork/TokenWithNetwork';

import './TokensPercentagesBar.scss';
import { generateColor } from '../../../utils/colors';
import { getValueByMultiProps } from '../../../utils/mapper';

const TokensPercentagesBar = ({ tokens = [] }) => {
  const [mainTokens, setMainTokens] = useState([]);
  const [otherTokens, setOtherTokens] = useState([]);
  const [remainingPerc, setRemainingPerc] = useState(0);
  const [notShownTokensNum, setNotShownTokensNum] = useState(0);

  const addColorToToken = (token) => {
    const color = generateColor(token.token_name || token.name);
    return { ...token, color };
  };
  const getPercentage = (token) => token.percentage || token?.current_ratio_from_pool;

  const sortedTokens = useMemo(
    () => tokens?.sort((a, b) => getPercentage(b) - getPercentage(a)).map(addColorToToken) || [],
    [tokens],
  );

  useEffect(() => {
    const _mainTokens = [...sortedTokens].slice(0, 4);
    setMainTokens([...sortedTokens].slice(0, 4));
    setOtherTokens([...sortedTokens].slice(4, 9));
    setRemainingPerc(100 - _mainTokens.reduce((acc, { percentage }) => acc + percentage, 0));
    setNotShownTokensNum([...sortedTokens].slice(9, sortedTokens.length).length);
  }, [tokens]);

  return (
    <div className="tokens-percentages-bar-wrapper">
      {sortedTokens.map((token) =>
        token.percentage === 0 && token.name === 'Tether' ? null : (
          <div
            key={token.token_id}
            className="tokens-percentages-bar-single-token-wrapper"
            style={{
              width: `${getValueByMultiProps(token, ['percentage', 'current_ratio_from_pool', 'token_ratio'])}%`,
            }}
          >
            <TokenWithNetwork token={token} />
            <div className="bar" style={{ backgroundColor: token.color }} />
          </div>
        ),
      )}
    </div>
  );
};

TokensPercentagesBar.propTypes = {
  tokens: PropTypes.array.isRequired,
};

export default TokensPercentagesBar;
